import { mdiChevronRight } from '@mdi/js';
import Icon from '@mdi/react';
import WaitListLink from './WaitListLink';

function HeroSection() {
  return (
    <section className="px-3 py-8 flex flex-col items-center bg-hero-pattern md:bg-hero-pattern-large bg-no-repeat bg-p-hero-pattern bg-contain xl:bg-auto">
      <div className="flex flex-col items-center justify-center w-full md:w-4/6 md:max-w-[900px] lg:min-h-72 xl:min-h-80 min-h-44 md:min-h-64 relative">
        <div className="py-3.5 px-10 md:py-5 md:px-14 lg:py-7 lg:px-16 bg-bgGold rounded-xl md:rounded-2xl flex justify-center absolute rotate-[4deg] top-3 md:top-5 lg:top-7">
          <p className="font-semibold text-xl md:text-3xl text-textGold lg:text-4xl xl:text-5xl ">
            Access
          </p>
        </div>
        <div className="py-3 px-2.5 md:py-6 md:px-5 w-10/12 md:w-11/12 lg:w-3/4 z-10 absolute top-[55px] md:top-[80px] lg:top-[100px] rotate-[-6deg] md:rotate-[-4deg] bg-bgGreen rounded-xl md:rounded-2xl flex justify-center">
          <p className=" font-semibold text-xl md:text-3xl text-textGreen lg:text-4xl xl:text-5xl">
            personalized Cloud Library
          </p>
        </div>
        <div className="px-7 py-3.5 md:py-6 md:px-10 w-10/12 md:w-11/12 lg:w-3/4 z-10 absolute top-[100px] md:top-[160px] lg:top-[190px] md:rotate-0 bg-bgPurple rounded-xl md:rounded-2xl flex justify-center">
          <p className=" font-semibold text-xl md:text-3xl text-textPurple lg:text-4xl xl:text-5xl">
            connect with community
          </p>
        </div>
      </div>

      <div className="flex flex-col items-center gap-8 md:mt-2">
        <p className="text-black-opaque-5 md:bg-white w-11/12 max-w-60 text-sm md:font-semibold md:max-w-2xl md:text-xl text-center">
          Join thousands of students transforming their study experience with
          seamless access to organized materials and powerful media integration
          on Gartekcloude!
        </p>
        <WaitListLink
          childEl={
            <button
              type="button"
              className="text-xs md:text-xl font-bold md:rounded-xl rounded-md text-white p-2 md:p-4 bg-gold flex gap-0.5 items-center justify-center"
            >
              <span className="flex items-center">Join Wait List Now!</span>
              <span className="flex items-center">
                <Icon path={mdiChevronRight} size={0.9} />
              </span>
            </button>
          }
        />
      </div>
    </section>
  );
}

export default HeroSection;
